import { render, staticRenderFns } from "./BlockedCustomer.vue?vue&type=template&id=05249569&scoped=true"
import script from "./BlockedCustomer.vue?vue&type=script&lang=js"
export * from "./BlockedCustomer.vue?vue&type=script&lang=js"
import style0 from "./BlockedCustomer.vue?vue&type=style&index=0&id=05249569&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05249569",
  null
  
)

export default component.exports